var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Job } from './job';
/**
 * 异步队列，用于批量执行异步任务，并且保持对任务执行状态的监控
 * 使用场景：
 * 1. 批量发送大量请求
 * 2. 批量合并大量dom操作
 * 3. 有前后依赖关系的异步请求
 * @example
 * // example 1
 * const queue = new JobQueue(1) // 默认最多同时执行1个异步任务, 相当于按照顺序执行异步任务
 * queue.enqueue(new Job(this.fetchData1))
 * queue.enqueue(new Job(this.fetchData2))
 * queue.enqueue(new Job(this.fetchData3))
 *
 * // example 2
 * const queue = new JobQueue(5) // 最多同时执行5个异步任务
 * queue.enqueue(new Job(this.fetchData1))
 * queue.enqueue(new Job(this.fetchData2))
 * queue.enqueue(new Job(this.fetchData3))
 */
var JobQueue = /** @class */ (function () {
    function JobQueue(_batchSize, _batchExec) {
        if (_batchSize === void 0) { _batchSize = 1; }
        if (_batchExec === void 0) { _batchExec = function (jobs) { return Promise.all(jobs.map(function (j) { return j.call(); })); }; }
        this._batchSize = _batchSize;
        this._batchExec = _batchExec;
        this._queue = [];
        if (_batchSize <= 0) {
            throw new Error("batchSize must >= 1, but got:".concat(_batchSize));
        }
    }
    /**
     * 在队列中加入一个 job 并且排队执行
     * @param job
     * @param batchExec 修改批量执行方法，默认是 Promise.all, 如果是批量同步任务也可以直接同时执行(比如修改dom)
     */
    JobQueue.prototype.enqueue = function (job) {
        var _this = this;
        this._queue.push(job);
        if (this._queue.length >= this._batchSize) {
            var jobs_1 = this._queue;
            this._queue = [];
            this._result = Promise.resolve(this._result).then(function () {
                return _this._batchExec(jobs_1);
            });
        }
        return job;
    };
    JobQueue.prototype.enqueueMany = function (jobs) {
        var _this = this;
        jobs.forEach(function (j) { return _this.enqueue(j); });
        return jobs;
    };
    /**
     * 类似 Promise.all/race，只不过是按照顺序执行 promises, 如果有一个报错则停止
     * @param promises
     */
    JobQueue.sync = function (promises) {
        return __awaiter(this, void 0, void 0, function () {
            var result, _i, _a, p, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        result = [];
                        _i = 0, _a = Array.from(promises);
                        _d.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        p = _a[_i];
                        if (p instanceof Job) {
                            p = p.call();
                        }
                        _c = (_b = result).push;
                        return [4 /*yield*/, p];
                    case 2:
                        _c.apply(_b, [_d.sent()]);
                        _d.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, result];
                }
            });
        });
    };
    return JobQueue;
}());
export { JobQueue };
//# sourceMappingURL=job-queue.js.map